import { defineStore } from "pinia"

export const useSchoolStore = defineStore("school", {
  state: () => ({
    schoolType: 1,
    bread: [
      {
        name: "全部",
        value: "",
        pageName: "PageAll"
      }
    ],
    curPage: {
      pageName: "PageAll",
      value: null
    }
  }),
  actions: {}
})
